import React, { forwardRef } from 'react';

import MUIOutlinedInput, {
  OutlinedInputProps as MUIOutlinedInputProps,
} from '@material-ui/core/OutlinedInput';

interface OutlinedInputProps extends MUIOutlinedInputProps {}

const OutlinedInput = forwardRef<HTMLInputElement, OutlinedInputProps>(
  function OutlinedInput(props, ref) {
    return <MUIOutlinedInput {...props} ref={ref} />;
  }
);

OutlinedInput.displayName = 'OutlinedInput';

export default OutlinedInput;
